module.exports = __webpack_public_path__ + "img/smart-home-angle-svgrepo-com.465c18ea.svg";